var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-nav"},[_c('div',{staticClass:"left-bar left-bar-desktop rounded mh-custom wall-card v-card"},[_c('left-bar-items')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }